import http from "../plugins/axios";
import { AxiosError } from "axios";
import { ArticleModel } from "./contest";
export interface StageModel {
  title: string;
  intro: string;
  id: number;
  configMaxSubmitPerDay: number;
  configMinHourPerSubmit: number;
  configStartTime: number;
  configEndTime: number;
  configShowRank: boolean;
  configShowResult: boolean;
  configRankLast: boolean;
  configRankBaseline: number;
  articles: ArticleModel[];
  frameLink: string;
  problems: number[];
  judgecount: number;
}
export type RankLiskInfo = {
  id: number; // judge id
  score: number; // judge score
  subScore: number; // judge sub score
  subTime: string;
  subCount: number;
  reverseRank: boolean;
};
export type RankListModel = Record<number, Record<number, RankLiskInfo>>; //team problem score

export interface RankShow {
  id: number;
  rank: number;
  fullScore: number;
  details: { [elem: number]: RankLiskInfo };
}
export function fetchOneStage(
  // token: string,
  contestId: number,
  trackId: number,
  stageId: number
): Promise<StageModel> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competition/${contestId}/track/${trackId}/stage/${stageId}`, {
        // headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as StageModel);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function fetchStages(
  // token: string,
  contestId: number,
  trackId: number
): Promise<StageModel[]> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competition/${contestId}/track/${trackId}/stage`, {
        // headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data.data as StageModel[]);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function fetchRankList(
  token: string,
  contestId: number,
  trackId: number,
  stageId: number
): Promise<RankListModel> {
  return new Promise((resolve, reject) => {
    http
      .get(
        `/api/competition/${contestId}/track/${trackId}/stage/${stageId}/ranklist`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(response.data.data as RankListModel);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}
